import React from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarCheck, Copy } from "@phosphor-icons/react";

const FIELDS = [
  ["customer", "Cliente"],
  ["phone", "Teléfono"],
  ["document", "Cédula / RNC"],
  ["vehicle", "Vehículo"],
  ["chassis", "Chasis"],
  ["reason", "Motivo"],
  ["branch", "Taller"],
  ["day", "Día"],
  ["time_slot", "Horario"],
];

export const AppointmentRequestCard = ({ data, customer }) => {
  const row = {
    ...data,
    customer: customer?.name,
    phone: customer?.phone,
    vehicle: [data.brand, data.model, data.year].filter(Boolean).join(" "),
  };
  const high = data.priority === "high" || data.priority === "urgent";

  const copy = async () => {
    const text = ["Cita de taller", ...FIELDS.map(([k, l]) => `${l}: ${row[k] || "pendiente"}`),
      `Prioridad: ${high ? "Alta" : "Normal"}`].join("\n");
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Datos de la cita copiados");
    } catch {
      toast.error("No se pudo copiar");
    }
  };

  return (
    <div className="mx-4 mt-3 rounded-lg border border-primary/30 bg-primary/5 p-3" data-testid="appointment-request-card">
      <div className="flex items-center justify-between gap-2 mb-2 flex-wrap">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary">
          <CalendarCheck size={14} weight="duotone" /> Cita de taller · lista para agendar
          {high && (
            <span className="rounded-full bg-red-500/15 text-red-600 px-2 py-0.5 text-[10px] normal-case tracking-normal" data-testid="appointment-priority-badge">
              Prioridad alta
            </span>
          )}
        </div>
        <Button size="sm" variant="outline" onClick={copy} className="h-7 text-xs gap-1" data-testid="appointment-copy-btn">
          <Copy size={13} /> Copiar datos
        </Button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
        {FIELDS.map(([k, label]) => (
          <div key={k} className="min-w-0" data-testid={`appointment-${k}`}>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
            <div className={`text-sm ${k === "chassis" || k === "document" ? "font-mono truncate" : "break-words"}`} title={row[k] || ""}>
              {row[k] || <span className="text-muted-foreground italic">pendiente</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
